import apiFetch from '../apiFetch'
export default function (orderId, makerNumber, token) {
  return apiFetch({ endPoint: `Order/${orderId}/UpdateMakerNumber/${makerNumber}`, method: 'PUT', token: token })
}
